"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDesignAreaCanvasSize = void 0;
var _pick = _interopRequireDefault(require("lodash/pick"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var getDesignAreaCanvasSize = exports.getDesignAreaCanvasSize = function getDesignAreaCanvasSize(designArea) {
  var baseShape = designArea.baseShape,
    position = designArea.position;
  var sourceObject;
  if (baseShape && baseShape.width && baseShape.height) {
    sourceObject = baseShape;
  } else if (position && position.width && position.height) {
    sourceObject = position;
  }
  if (!sourceObject) {
    // eslint-disable-next-line no-console
    console.error("Incomplete design area data, baseShape and position has to be set up correctly.", designArea);
    throw new Error("There is no valid source object provided to get the width and height for the canvas!");
  }
  return (0, _pick["default"])(sourceObject, ["width", "height"]);
};